var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUcu40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 592 522",
    width: 400,
    height: 353,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m300.91 280.6v-157.25c0-85.93 73.41-121.59 145.21-121.59 70.72 0 144.68 35.12 144.68 123.21v154.55c0 84.3-75.58 120.51-144.14 120.51-69.1 0-145.75-31.35-145.75-119.43zm193.8-2.7v-157.79c0-24.32-17.28-43.78-48.05-43.78-31.31 0-49.12 20-49.12 45.39v157.26c0 24.32 16.19 45.93 49.12 45.93 32.39 0 48.05-23.23 48.05-47.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m162.98 302.19h-162.16v-67.59l139.3-229.38h102.07l-146.73 226.18h67.52v-46.83l87.72-56.41v103.24h39.87v70.79h-39.87v83.02h-87.72z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m163.53 302.77h-162.15v-67.59l139.29-229.38h102.08l-146.73 226.19h67.51v-46.84l87.73-56.41v103.25h39.87v70.78h-39.87v83.02h-87.73z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #1f3969 } \n\t\t.s1 { fill: #e85c0c } \n\t\t.s2 { fill: #ffffff } \n\t\t.s3 { fill: #92c021 } \n\t\t.s4 { fill: #c63b8d } \n\t\t.s5 { fill: #fab806 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m301.28 281.12v-157.25c0-85.93 73.42-121.59 145.22-121.59 70.72 0 144.68 35.12 144.68 123.21v154.55c0 84.3-75.58 120.51-144.14 120.51-69.1 0-145.76-31.35-145.76-119.43zm193.81-2.7v-157.8c0-24.32-17.28-43.77-48.05-43.77-31.31 0-49.12 19.99-49.12 45.39v157.26c0 24.32 16.19 45.93 49.12 45.93 32.39 0 48.05-23.24 48.05-47.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m163.36 302.7h-162.16v-67.58l139.29-229.38h102.08l-146.73 226.18h67.52v-46.83l87.72-56.41v103.24h39.87v70.78h-39.87v83.03h-87.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m238.96 519.84h-162.8c-41.03 0-74.29-33.26-74.29-74.29v-34.73h237.09z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m75.01 472.33c0-7.62 6.99-10.14 12.56-10.14h9.92v-5.23c0-5.31-3.53-7.14-8.63-7.14-4.21 0-8.69 1.5-8.69 5.91v1.09h-3.67v-1.02c0-6.73 6.25-9.24 12.57-9.24 6.59 0 12.43 2.37 12.43 9.72v16.45c0 1.97 0.27 7.01 0.47 8.5h-3.94c-0.13-1.15-0.27-4.35-0.27-5.37h-0.13c-2.79 5.24-7.34 6.12-11.48 6.12-6.12 0-11.14-3.4-11.14-9.65zm22.48-3.34v-3.8h-9.1c-4.62 0-9.37 1.15-9.37 6.93 0 4.56 3.93 6.73 8.21 6.73 6.8 0 10.26-4.01 10.26-9.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m107.68 447.37h3.81v6.46h0.13c2.38-4.83 6.93-7.27 11.68-7.27 7.07 0 10.53 4.76 10.53 10.67v24h-4.01v-22.16c0-6.33-3.12-8.98-7.74-8.98-5.36 0-10.46 4.22-10.46 10.88v20.26h-3.94zm1.5-6.05c0.54-3.4 2.64-6.12 6.11-6.12 3.73 0 6.86 2.52 10.25 2.52 2.04 0 2.79-1.36 3.33-3.27l2.72 0.55c-0.75 3.67-2.92 6.12-6.05 6.12-3.66 0-6.92-2.52-10.46-2.52-1.83 0-2.51 1.36-3.19 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m138.66 469.13v-9.11c0-8.84 5.97-13.4 13.72-13.4 8.35 0 13.72 4.76 13.72 13.33v8.77c0 8.77-5.78 13.4-13.59 13.4-8.29 0-13.85-4.42-13.85-12.99zm23.43-0.34v-9.18c0-5.51-3.06-9.59-9.71-9.59-6.39 0-9.72 3.81-9.72 9.86v9.11c0 5.78 3.19 9.73 9.85 9.73 6.39 0 9.58-3.47 9.58-9.93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m168.75 477.09l2.71-2.32c2.86 2.72 6.05 4.08 10.53 4.08 4.35 0 8.76-2.38 8.76-6.73 0-4.15-2.58-5.44-7.26-6.32l-3.74-0.82c-5.98-1.15-9.58-3.87-9.58-8.63 0-5.51 4.28-9.79 11.75-9.79 4.76 0 8.7 1.08 11.28 3.73l-2.65 2.25c-2.17-1.77-4.96-2.86-8.96-2.86-4.49 0-7.48 2.52-7.48 5.99 0 3.53 2.72 4.89 7.68 5.98l5.03 1.09c4.75 1.09 8.08 3.6 8.08 8.57 0 7.14-6.45 10.74-12.84 10.74-5.37 0-10.19-1.36-13.31-4.96z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m315.97 442.77h-6.38v6.51h-4.84v-6.51h-6.38v-5.19h6.38v-6.51h4.84v6.51h6.38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m376.08 477.32v-50.5h16.6v48.98c0 9.14 4.47 15.35 14.25 15.35 9.15 0 14.05-5.23 14.05-15.35v-48.98h16.38v49.53c0 18.93-12.98 29.38-30.75 29.38-18.4 0-30.53-9.36-30.53-28.41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m449.17 478.3v-24.16c0-18.73 14.37-28.63 31.07-28.63 14.57 0 29.9 7.94 29.9 25.58v3.05h-15.64v-1.53c0-9.03-7.77-12.73-14.16-12.73-6.91 0-14.68 3.81-14.68 13.71v24.16c0 8.61 6.81 13.62 15.11 13.62 6.38 0 13.73-3.7 13.73-12.85v-1.42h15.64v3.05c0 17.64-14.79 25.58-29.47 25.58-16.61 0-31.5-9.03-31.5-27.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m521.41 477.32v-50.5h16.6v48.98c0 9.14 4.47 15.35 14.25 15.35 9.16 0 14.05-5.23 14.05-15.35v-48.98h16.38v49.53c0 18.93-12.98 29.38-30.74 29.38-18.41 0-30.54-9.36-30.54-28.41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m351.18 455.02v21.2c0 24.83-19.74 45.02-44.01 45.02-24.26 0-44.01-20.19-44.01-45.02v-21.2c0-24.82 19.75-45.02 44.01-45.02 24.27 0 44.01 20.2 44.01 45.02zm-8.53 21.2v-21.2c0-20.05-15.88-36.3-35.48-36.3-19.6 0-35.48 16.25-35.48 36.3v21.2c0 20.05 15.88 36.3 35.48 36.3 19.6 0 35.48-16.25 35.48-36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m281.24 492.79h51.87c1.51-2.43 2.65-5.06 3.37-7.84h-58.62c0.72 2.78 1.87 5.41 3.38 7.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m286.37 498.99c5.21 4.81 12.16 7.84 19.82 7.84h1.96c7.66 0 14.61-3.03 19.83-7.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m307.17 460.49l-29.82 17.55v0.74h59.65v-0.74z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m288.33 254.35v97.75c107.86 0 195.29-87.52 195.29-195.5h-97.64c0 53.99-43.72 97.75-97.65 97.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m317.31-12.67c0 90.08 72.95 163.11 162.94 163.11 89.99 0 162.94-73.03 162.94-163.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m268.69 177.46v-142.88c-157.66 0-285.45 127.93-285.45 285.75h142.72c0-78.91 63.9-142.87 142.73-142.87z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m426.71 437.93c0-79.8-64.62-144.48-144.33-144.48-79.71 0-144.33 64.68-144.33 144.48z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUcu40);
export default __webpack_public_path__ + "static/media/ucu-40.3710ae456f745c5b9b74f0b3cd4429bb.svg";
export { ForwardRef as ReactComponent };